import { render, staticRenderFns } from "./billPackStockListV4.vue?vue&type=template&id=72f91e2f&scoped=true&"
import script from "./billPackStockListV4.vue?vue&type=script&lang=js&"
export * from "./billPackStockListV4.vue?vue&type=script&lang=js&"
import style0 from "./billPackStockListV4.vue?vue&type=style&index=0&id=72f91e2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f91e2f",
  null
  
)

export default component.exports